import { render, staticRenderFns } from "./smarttagfield.vue?vue&type=template&id=0af6ce46&scoped=true"
import script from "./smarttagfield.vue?vue&type=script&lang=js"
export * from "./smarttagfield.vue?vue&type=script&lang=js"
import style0 from "./smarttagfield.vue?vue&type=style&index=0&id=0af6ce46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af6ce46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VCheckbox,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle})
